import { Box, Container } from "@mui/material";
import { getArrayOfGivenLength } from "@Services/Helper";
import ContentLoader from "react-content-loader";
import styled from "styled-components";
import { StyledCategoryPageSkeleton } from "@Styled/Constant";
import React from "react";

export const CategorySkeleton = styled.rect`
  x: 0px;
  y: 20px;
  rx: 5px;
  ry: 5px;
  width: 50vh;
  height: 50vh;
`;

export const Root = styled(ContentLoader)`
  width: ${(props: any) => props.width || "25%"};
  height: ${(props: any) => props.height || "25vh"};
`;

const carouselCategorySkeleton = (
  <Root width="100%" height="45vh">
    <CategorySkeleton />
  </Root>
);

export const carouselHeroSkeleton = (
  <Root width="100%" height="30rem">
    <rect x="0" width="93rem" height="30rem" />
    {/* <rect x="5" y="5" rx="5" ry="5" width="100" height="100" /> */}
  </Root>
);

const poductsSkelton = (
  <>
    <rect x="20" y="25" width="20.5rem" height="220" />
    <rect x="20" y="150" width="6.25rem" height="5" />
    <rect x="20" y="260" rx="4" ry="4" width="7.25rem" height="15" />
    <rect x="20" y="290" rx="4" ry="4" width="5rem" height="15" />
    <rect x="19rem" y="290" rx="4" ry="4" width="2rem" height="20" />
    <rect x="20" y="320" rx="4" ry="4" width="13.75rem" height="35" />
  </>
);
const carouselProductSkeleton = (
  <Root width="100%" height={400}>
    {poductsSkelton}
  </Root>
);

const mobileCarouselProductSkeleton = (
  <Root width="100%" height={400}>
    <rect x="1" y="1" width="3.5rem" height="220" />
    <rect x="95" y="1" width="15.5rem" height="220" />
    <rect x="95" y="130" width="6.25rem" height="5" />
    <rect x="95" y="240" rx="4" ry="4" width="6.25rem" height="5" />
    <rect x="95" y="260" rx="4" ry="4" width="3.75rem" height="5" />
    <rect x="95" y="280" rx="4" ry="4" width="13.75rem" height="35" />
  </Root>
);

// export const categoryBoxSkeleton = (
//   <>
//     <Root width="100%" height="10rem">
//       <rect x="20rem" y="1rem" width="12rem" height="4rem" />
//       <rect x="35rem" y="1rem" width="12rem" height="4rem" />
//       <rect x="50rem" y="1rem" width="12rem" height="4rem" />
//       <rect x="65rem" y="1rem" width="12rem" height="4rem" />
//     </Root>
//   </>
// );
export const categoryCarouselProductSkeleton = (
  <>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexWrap: {
          xs: "wrap",
          sm: "nowrap",
        },
      }}
    >
      {carouselCategorySkeleton}
      {getArrayOfGivenLength(4).map((index) => (
        <React.Fragment key={index}>{carouselProductSkeleton}</React.Fragment>
      ))}
    </Box>
  </>
);

const categoryPageProductSkeleton = (
  <StyledCategoryPageSkeleton>{poductsSkelton}</StyledCategoryPageSkeleton>
);

export const CategoryPageSkeleton = (
  <>
    {carouselHeroSkeleton}
    <Container>
      {getArrayOfGivenLength(9).map((index) => (
        <React.Fragment key={index}>
          {categoryPageProductSkeleton}
        </React.Fragment>
      ))}
    </Container>
  </>
);

export const mobileCarouselSkeleton = (
  <>
    {getArrayOfGivenLength(4).map((index) => (
      <React.Fragment key={index}>
        {mobileCarouselProductSkeleton}
      </React.Fragment>
    ))}
  </>
);

const producutImage = (
  <>
    <Root width="100%" height="70vh">
      {/* image */}
      <rect x="10" y="70" width="70vh" height="50vh" />
      {/* add to cart button */}
      <rect x="140" y="450" rx="4" ry="4" width="160" height="5vh" />
    </Root>
  </>
);

const producutImageMobile = (
  <>
    <Root width="100%" height="60vh">
      <rect x="10" y="70" width="60vh" height="60vh" />
    </Root>
  </>
);

const categoyImageMobile = (
  <>
    <Root width="25%" height="15vh">
      <circle cx="35" cy="35" r="35" />
    </Root>
  </>
);
export const CategoryImageMobileSkeleton = (
  <Container style={{ marginTop: "3rem " }}>
    {getArrayOfGivenLength(4).map((index) => (
      <React.Fragment key={index}> {categoyImageMobile}</React.Fragment>
    ))}
  </Container>
);
const producutDetail = (
  <>
    <Root width="100%" height="50vh">
      {/* name */}
      <rect x="25" y="100" rx="4" ry="4" width="25vh" height="20" />
      {/* rating */}
      <rect x="25" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="25" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="55" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="85" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="115" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="150" y="140" rx="4" ry="4" width="20" height="20" />
      <rect x="180" y="130" rx="4" ry="4" width="5" height="35" />
      <rect x="200" y="140" rx="4" ry="4" width="50" height="20" />

      {/* MRP */}
      <rect x="25" y="170" rx="4" ry="4" width="15vh" height="10" />
      {/* price */}
      <rect x="25" y="195" rx="4" ry="4" width="15vh" height="10" />

      <rect x="25" y="215" rx="4" ry="4" width="15vh" height="5" />

      {/* Volume */}
      <rect x="20" y="242" rx="4" ry="4" width="10vh" height="10" />
      <rect x="110" y="240" rx="4" ry="4" width="5vh" height="20" />
      <rect x="160" y="240" rx="4" ry="4" width="5vh" height="20" />
      <rect x="220" y="240" rx="4" ry="4" width="5vh" height="20" />

      {/* tabs */}
      <rect x="25" y="280" rx="4" ry="4" width="10vh" height="20" />
      <rect x="110" y="280" rx="4" ry="4" width="10vh" height="20" />
      <rect x="200" y="280" rx="4" ry="4" width="10vh" height="20" />

      {/* rating & reviews*/}
      <rect x="25" y="340" rx="4" ry="4" width="30" height="25" />
      <rect x="65" y="340" rx="4" ry="4" width="30vh" height="25" />

      {/* write a review button */}
      <rect x="25" y="380" rx="4" ry="4" width="20vh" height="35" />

      {/*  reviews */}
      <rect x="25" y="440" rx="4" ry="4" width="20" height="20" />
      <rect x="55" y="440" rx="4" ry="4" width="20" height="20" />
      <rect x="85" y="440" rx="4" ry="4" width="20" height="20" />
      <rect x="115" y="440" rx="4" ry="4" width="20" height="20" />
      <rect x="150" y="440" rx="4" ry="4" width="20" height="20" />
    </Root>
  </>
);

export const productDetailInMobile = (
  <>
    <Root width="100%" height="100vh">
      {/* name */}
      <rect x="25" y="15" rx="4" ry="4" width="25vh" height="20" />
      {/* rating */}
      <rect x="25" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="25" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="55" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="85" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="115" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="150" y="55" rx="4" ry="4" width="20" height="20" />
      <rect x="180" y="45" rx="4" ry="4" width="5" height="35" />
      <rect x="200" y="55" rx="4" ry="4" width="50" height="20" />
      {/* MRP */}
      <rect x="25" y="95" rx="4" ry="4" width="25vh" height="10" />
      {/* price */}
      <rect x="25" y="115" rx="4" ry="4" width="25vh" height="10" />
      <rect x="25" y="140" rx="4" ry="4" width="25vh" height="10" />
      <rect x="25" y="160" rx="4" ry="4" width="25vh" height="10" />
    </Root>
  </>
);
export const productDetailsSkeleton = (
  <>
    <Container sx={{ display: "flex", flexDirection: { md: "row" } }}>
      {producutImage}
      {producutDetail}
    </Container>
  </>
);

export const productDetailsSkeletonInMobile = (
  <>
    <Container sx={{ display: "flex", flexDirection: { xs: "column" } }}>
      {producutImageMobile}
      {productDetailInMobile}
    </Container>
  </>
);

const cartSkeleton = (
  <>
    <Root width="100%" height="10rem">
      <rect x="2rem" y="1rem" width="8rem" height="8rem" />
      <rect x="12rem" y="4rem" width="20rem" height="1rem" />
      <rect x="35rem" y="4rem" width="8rem" height="1rem" />
      <rect x="47rem" y="3rem" width="3rem" height="2.5rem" />
      <rect x="55rem" y="4rem" width="8rem" height="1rem" />
    </Root>
  </>
);

const mobileCartSkeleton = (
  <>
    <Root width="100%" height="10rem">
      <rect x="1rem" y="1rem" width="5rem" height="5rem" />
      <rect x="7rem" y="1.5rem" width="10rem" height="1rem" />
      <rect x="20rem" y="1rem" width="2rem" height="2rem" />
      <rect x="7rem" y="4rem" width="5rem" height="1rem" />
      <rect x="20rem" y="4rem" width="1.5rem" height="1.2rem" />
    </Root>
  </>
);

export const myCartSkeleton = (
  <>
    <Box sx={{ marginLeft: { lg: "10rem" } }}>
      {getArrayOfGivenLength(2).map((index) => (
        <React.Fragment key={index}>{cartSkeleton}</React.Fragment>
      ))}
    </Box>
  </>
);

export const myCartMobileSkeleton = (
  <>
    <Box sx={{ marginLeft: { lg: "10rem" } }}>
      {getArrayOfGivenLength(2).map((index) => (
        <React.Fragment key={index}>{mobileCartSkeleton}</React.Fragment>
      ))}
    </Box>
  </>
);

export const profileSkeleton = (
  <>
    <Root width="100%" height="12rem">
      <rect x="1rem" y="0.5rem" width="2rem" height="1.5rem" />
      <rect x="7rem" y="0.7rem" width="5rem" height="1rem" />
      <rect x="1rem" y="3rem" width="15rem" height="1rem" />
      <rect x="1rem" y="5rem" width="20rem" height="0.5rem" />
      <rect x="1rem" y="6rem" width="15rem" height="0.5rem" />
      <rect x="1rem" y="8rem" width="15rem" height="1rem" />
      <rect x="1rem" y="10rem" width="15rem" height="1rem" />
    </Root>
  </>
);

export const myprofileSkeleton = (
  <>
    <Box sx={{ display: "flex" }}>
      {getArrayOfGivenLength(2).map((index) => (
        <React.Fragment key={index}>{profileSkeleton}</React.Fragment>
      ))}
    </Box>
  </>
);

export const myOrderSkeleton = (
  <>
    <Box sx={{ marginTop: "2rem" }}>
      <Root width="100%" height="30rem">
        {/* order id */}
        <rect x="2rem" y="" width="5rem" height="1rem" />
        <rect x="2rem" y="1.5rem" width="13rem" height="0.5rem" />
        {/* order date */}
        <rect x="20rem" y="" width="5rem" height="1rem" />
        <rect x="20rem" y="1.5rem" width="7rem" height="0.5rem" />
        {/* order arrived on */}
        <rect x="30rem" y="" width="5rem" height="1rem" />
        <rect x="30rem" y="1.5rem" width="7rem" height="0.5rem" />
        {/* mode of payment */}
        <rect x="40rem" y="" width="5rem" height="1rem" />
        <rect x="40rem" y="1.5rem" width="7rem" height="0.5rem" />
        {/* proccessing n track */}
        <rect x="55rem" y="0.5rem" width="9rem" height="1rem" />
        <rect x="65rem" y="" width="15rem" height="2rem" />
        {/* image */}
        <rect x="2rem" y="4rem" width="4rem" height="4rem" />
        <rect x="7rem" y="4rem" width="5rem" height="1rem" />
        <rect x="7rem" y="6rem" width="10rem" height="0.5rem" />
        {/* unit quantity amount */}
        <rect x="45rem" y="4rem" width="5rem" height="1rem" />
        <rect x="45rem" y="5.5rem" width="6rem" height="0.4rem" />

        <rect x="55rem" y="4rem" width="5rem" height="1rem" />
        <rect x="55rem" y="5.5rem" width="6rem" height="0.4rem" />

        <rect x="65rem" y="4rem" width="5rem" height="1rem" />
        <rect x="65rem" y="5.5rem" width="6rem" height="0.4rem" />

        {/* shipping to */}
        <rect x="1rem" y="12rem" width="15rem" height="1rem" />
        <rect x="1rem" y="14rem" width="12rem" height="1rem" />
        <rect x="1rem" y="16rem" width="5rem" height="1rem" />
        <rect x="1rem" y="18rem" width="20rem" height="0.5rem" />
        <rect x="1rem" y="19.5rem" width="15rem" height="0.5rem" />
        <rect x="1rem" y="21rem" width="15rem" height="1rem" />

        <rect x="55rem" y="12rem" width="25rem" height="1rem" />
        <rect x="65rem" y="14rem" width="12rem" height="1rem" />
        <rect x="55rem" y="16rem" width="25rem" height="1rem" />
        <rect x="55rem" y="18rem" width="25rem" height="0.5rem" />
        <rect x="55rem" y="19.5rem" width="25rem" height="0.5rem" />
      </Root>
    </Box>
  </>
);
const mobileOrder = (
  <>
    <Root width="100%" height="16rem">
      {/* order id */}
      <rect x="1rem" y="" width="5rem" height="1rem" />
      <rect x="1rem" y="1.5rem" width="13rem" height="0.5rem" />
      {/* order date */}
      <rect x="15rem" y="" width="5rem" height="1rem" />
      <rect x="15rem" y="1.5rem" width="7rem" height="0.5rem" />
      {/* image */}
      <rect x="1rem" y="4rem" width="4rem" height="4rem" />
      <rect x="7rem" y="4rem" width="5rem" height="1rem" />
      <rect x="7rem" y="6rem" width="10rem" height="0.5rem" />

      <rect x="1rem" y="9rem" width="15rem" height="0.6rem" />
      {/* track n detail button */}
      <rect x="15rem" y="11rem" width="10rem" height="2rem" />
      <rect x="7rem" y="11rem" width="7rem" height="2rem" />
    </Root>
  </>
);
export const mobileMyOrderSkeleton = (
  <>
    <Box sx={{ marginTop: "2rem", display: "flex", flexDirection: "column" }}>
      {getArrayOfGivenLength(2).map((index) => (
        <React.Fragment key={index}>{mobileOrder}</React.Fragment>
      ))}
    </Box>
  </>
);

export const checkoutSkeleton = (
  <>
    <Root width="100%" height="10rem">
      <rect x="1rem" y="1rem" width="15rem" height="1rem" />
      <rect x="1rem" y="3rem" width="20rem" height="0.5rem" />
      <rect x="1rem" y="4rem" width="15rem" height="0.5rem" />
      <rect x="1rem" y="6rem" width="15rem" height="1rem" />
      <rect x="1rem" y="8rem" width="15rem" height="1rem" />
    </Root>
  </>
);

export const orderSummerySkeleton = (
  <>
    <Box sx={{ marginTop: "2rem" }}>
      <Root width="100%" height="20rem">
        <rect x="1rem" y="1rem" width="10rem" height="1rem" />
        <rect x="1rem" y="3rem" width="7rem" height="1rem" />
        <rect x="12rem" y="3rem" width="5rem" height="1rem" />
        <rect x="1rem" y="5rem" width="12rem" height="2rem" />
        <rect x="15rem" y="5rem" width="5rem" height="2rem" />
        <rect x="1rem" y="8rem" width="15rem" height="1rem" />
        <rect x="1rem" y="10rem" width="15rem" height="1rem" />
        <rect x="1rem" y="12rem" width="20rem" height="3rem" />
      </Root>
    </Box>
  </>
);

const yourOrder = (
  <>
    <Root width="100%" height="5rem">
      <rect x="0" y="1rem" width="3rem" height="3rem" />
      <rect x="6rem" y="2rem" width="8rem" height="1rem" />
      <rect x="16rem" y="2rem" width="8rem" height="1rem" />
      <rect x="26rem" y="2rem" width="4rem" height="1rem" />
    </Root>
  </>
);
export const yourOrderSkeleton = (
  <>
    {getArrayOfGivenLength(2).map((index) => (
      <React.Fragment key={index}>{yourOrder}</React.Fragment>
    ))}
  </>
);

const reviewProduct = (
  <>
    <Root width="100%" height="10rem">
      <rect x="1rem" y="2rem" width="15rem" height="1rem" />
      <rect x="1rem" y="4rem" width="15rem" height="1rem" />
      <rect x="1rem" y="6rem" width="10rem" height="2rem" />

      <rect x="25rem" y="2rem" width="5rem" height="5rem" />
      <rect x="32rem" y="3rem" width="15rem" height="1rem" />
      <rect x="32rem" y="5rem" width="10rem" height="1rem" />
    </Root>
  </>
);

const allReview = (
  <>
    <Root width="100%" height="9rem">
      <rect x="1rem" y="1rem" width="10rem" height="1rem" />
      <rect x="1rem" y="3rem" width="7rem" height="1rem" />
      <rect x="1rem" y="5rem" width="40rem" height="0.5rem" />
      <rect x="1rem" y="6rem" width="30rem" height="0.5rem" />
    </Root>
  </>
);
export const allReviewsSkeleton = (
  <>
    <Container style={{ marginTop: "1rem" }}>
      {reviewProduct}
      {getArrayOfGivenLength(3).map((index) => (
        <React.Fragment key={index}>{allReview}</React.Fragment>
      ))}
    </Container>
  </>
);
